<script>
    import moment from 'moment'

    export let column
    export let startWorkDate
    export let rowHeight
    export let colWidth
    export let firstColumnWidth
    export let firstRowHeight
    export let margin
    export let worksheet

    const begin = moment(worksheet.begin)
    const end = moment(worksheet.end)

    const left = column * colWidth + firstColumnWidth + margin
    const top = (begin - startWorkDate) / (1000 * 60 * 15) * rowHeight + firstRowHeight + margin
    const height = rowHeight * 4 * (end - begin + 1000) / 3600000 - 2 * margin
    const statusToBackgroundClass = {
        1: 'bg-info',
        2: 'bg-primary',
        3: 'bg-success',
        4: 'bg-danger',
        5: 'bg-warning',
        6: 'bg-secondary'
    }
    $: backgroundClass = statusToBackgroundClass[worksheet.status]

    const statusToForegroundClass = {
        1: 'text-black',
        2: 'text-white',
        3: 'text-white',
        4: 'text-white',
        5: 'text-black',
        6: 'text-white'
    }
    $: foregroundClass = statusToForegroundClass[worksheet.status]

    function worksheetMouseEnter(e) {
        setTargetSize(e.target, colWidth - margin * 2, Math.max(height, rowHeight * 10 - margin * 2), 100)
    }

    function worksheetMouseLeave(e) {
        setTargetSize(e.target, colWidth - margin * 2, height, 1)
    }

    function setTargetSize(t, w, h, z) {
        t.style.width = `${w}px`
        t.style.height = `${h}px`
        t.style.zIndex = `${z}`
    }
</script>
<a class="dashboard-item {backgroundClass} {foregroundClass}"
   href="/worksheet/view?id={worksheet.id}"
   style:height="{height}px"
   style:left="{left}px"
   style:top="{top}px"
   style:width="{colWidth - 2 * margin}px"
   on:mouseenter={e => worksheetMouseEnter(e)}
   on:mouseleave={e => worksheetMouseLeave(e)}
>
    <div>👨{ worksheet.name }</div>
    <div>☎️{ worksheet.phone }</div>
    <div>💵{ worksheet.sum } ₽</div>
    {#if worksheet.comment}
        <div>📝{ worksheet.comment }</div>
    {/if}
</a>

<style>
    .dashboard-item {
        color: #000;
        padding: 8px;
        border-radius: 8px;
        position: absolute;
        display: flex;
        justify-content: start;
        flex-direction: column;
        text-decoration: none;
        overflow: clip;
    }

    .dashboard-item:hover, .dashboard-item:active {
        color: #fff;
        padding: 6px;
        border-color: #178561;
        border-width: 2px;
        border-style: solid;
    }
</style>
